import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import al from "../portofolio-al.json";
import en from "../portofolio-en.json";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: en,
    },
    al: {
      translation: al,
    },
  },
});

export default i18n;
